import { makeAutoObservable, reaction } from 'mobx';
import { CheckContactViewModel } from '@widgets/auth/checkContact/types';
import { injectable } from 'inversify';
import { type CheckContactValues } from '@widgets/auth/checkContact/config/phoneValidation';
import { makePersistable } from 'mobx-persist-store';
import { NavigateFunction } from 'react-router-dom';
import { PATH_AUTH } from '@app/routes/paths';
import { queryClient } from '@shared/api/reactQuery';
import { notifications } from '@shared/utils/notifications';
import { reformatPhone } from '@shared/utils/helpers/formatString';
import { getGetApiAuthCheckContactPhoneQueryOptions } from '@/shared/api/orval/auth/auth';

@injectable()
export class ViewModel implements CheckContactViewModel {
  initialPhone = localStorage.getItem('phone') ?? '';

  isRemember = true;

  navigate: NavigateFunction | null = null;

  isLoading = false;

  constructor() {
    makeAutoObservable(this);
    void makePersistable(this, { name: 'CheckContactViewModel', properties: ['isRemember'] });

    reaction(
      () => this.initialPhone,
      (phone) => {
        localStorage.setItem('phone', phone);
      }
    );
  }

  checkContact = async (values: CheckContactValues) => {
    if (!this.navigate) return;

    const queryOptions = getGetApiAuthCheckContactPhoneQueryOptions(reformatPhone(values.phone));
    try {
      this.isLoading = true;
      const response = await queryClient.fetchQuery({ ...queryOptions, staleTime: 0, gcTime: 0 });

      if (!response.result) return;
      const { isRegistered, hasPassword, isContacted, botUrl } = response.result;

      if (!isRegistered || !hasPassword) {
        // Fix: передаём isContacted чтобы при повторной регистрации не ждать повторного share contact
        this.navigate(PATH_AUTH.register, { state: { phone: values.phone, isFreshRegistration: true, isContacted, botUrl } });
        return;
      }

      this.initialPhone = this.isRemember ? values.phone : '';

      this.navigate(PATH_AUTH.login, { state: { phone: values.phone, isContacted, botUrl } });
    } catch (e) {
      notifications.error();
      console.error(e);
    } finally {
      this.isLoading = false;
    }
  };

  toggleIsRemember = () => {
    this.isRemember = !this.isRemember;
  };

  forgotPasswordClick = (phone: string) => {
    if (!this.navigate) return;
    this.navigate(PATH_AUTH.resetPassword, { state: { phone } });
  };
}
